import React from 'react';
import { Star } from 'lucide-react';
import { isMobile, isTablet } from '../../../shared/utils/deviceUtils';

const testimonials = [
  {
    name: 'Sarah Johnson',
    location: 'United States',
    rating: 5,
    comment:
      'An incredible experience! The safari exceeded all our expectations. The guides were knowledgeable and the wildlife sightings were amazing.',
    image: 'https://images.pexels.com/photos/4577791/pexels-photo-4577791.jpeg',
    safari: 'Serengeti Wildlife Explorer',
  },
  {
    name: 'David Chen',
    location: 'Singapore',
    rating: 5,
    comment:
      'Professional guides and amazing wildlife sightings. The accommodation was top-notch and the whole experience was seamless.',
    image: 'https://images.pexels.com/photos/4577801/pexels-photo-4577801.jpeg',
    safari: 'Ngorongoro Crater Safari',
  },
  {
    name: 'Emma Watson',
    location: 'United Kingdom',
    rating: 5,
    comment:
      "A life-changing adventure that we'll never forget. The attention to detail and care from the team was exceptional.",
    image: 'https://images.pexels.com/photos/631317/pexels-photo-631317.jpeg',
    safari: 'Kilimanjaro Trek',
  },
];

export const Testimonials: React.FC = () => {
  const mobile = isMobile();
  const tablet = isTablet();

  return (
    <section
      className={`${mobile ? 'py-16' : tablet ? 'py-20' : 'py-24'} bg-background-secondary`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2
            className={`${mobile ? 'text-3xl' : tablet ? 'text-4xl' : 'text-4xl'} font-bold text-text-primary mb-4`}
          >
            What Our Travelers Say
          </h2>
          <p
            className={`${mobile ? 'text-base' : 'text-lg'} text-text-secondary max-w-2xl mx-auto`}
          >
            Don't just take our word for it - hear from our satisfied travelers
            about their unforgettable safari experiences.
          </p>
        </div>

        <div
          className={`grid ${mobile ? 'grid-cols-1 gap-6' : tablet ? 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6' : 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8'} justify-items-start p-4 sm:p-6 lg:p-8`}
        >
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl ${mobile ? 'p-4' : 'p-6'} shadow-soft hover:shadow-large transition-all duration-300 text-left`}
            >
              <div className="flex items-center gap-2 mb-3 sm:mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className={`${mobile ? 'w-4 h-4' : 'w-5 h-5'} text-yellow-400 fill-current`}
                  />
                ))}
              </div>
              <p
                className={`${mobile ? 'text-sm' : 'text-base'} text-text-secondary mb-4 sm:mb-6 leading-relaxed`}
              >
                "{testimonial.comment}"
              </p>
              <div className="flex items-center gap-3 sm:gap-4">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className={`${mobile ? 'w-10 h-10' : 'w-12 h-12'} rounded-full object-cover`}
                />
                <div>
                  <h4
                    className={`${mobile ? 'text-sm' : 'font-semibold'} text-text-primary`}
                  >
                    {testimonial.name}
                  </h4>
                  <p
                    className={`${mobile ? 'text-xs' : 'text-sm'} text-text-tertiary`}
                  >
                    {testimonial.location}
                  </p>
                  <p
                    className={`${mobile ? 'text-xs' : 'text-sm'} text-primary mt-1`}
                  >
                    {testimonial.safari}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
